import React, { Fragment, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import HeaderEjercicios from '../../../../AuxiliaresPaginas/HeaderEjercicios';
import Instrucciones from '../../../../Escritorio/Instrucciones';
import BotoneraBottom from '../../../Compartidos/BotoneraBottom';
import useConfigAuth from '../../../../../Hooks/useConfigAuth';

import { finalizarEjercicioAction, setearEjercicioAction, setearUrlAnteriorAction } from '../../../../../actions/estadoEjercicioActions';
import { almacenarAction } from '../../../../../actions/almacenarEjercicioActions';

//css
import { ContainerFlex } from '../../../../Css/MetodosCSS/StyledLN2Todos';
import { BtnLetra } from '../../../../Css/MetodosCSS/StyledEjercicios';
import { AvanzarBtn, AvanzarImg, Img } from '../../../../Css/StyledMatematica';

const instrucciones = 'Vas a ver una imagen y tres oraciones. Solo una de las oraciones corresponde a la imagen. Debes selecccionarla.';
const miniInstrucciones = 'Selecciona la oración que le corresponde a la imagen.';

const CL1 = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [config] = useConfigAuth();

    const [comparar, setComparar] = useState([]);
    const [disable, setDisable] = useState(false);
    const [randomPalabra, setRandomPalabra] = useState([]);
    const [fraseElegida, setFraseElegida] = useState('');
    const [count, setCount] = useState(1);
    const [indexes, setIndexes] = useState();
    const [isIncorrect, setIsIncorrect] = useState(false);
    const [isCorrect, setIsCorrect] = useState(false);
    const [contarErrores, setContarErrores] = useState(0);

    const iniciar = useSelector(state => state.ejercicio.iniciar);
    const finalizar = useSelector(state => state.ejercicio.finalizar);
    const id_paciente = useSelector((state) => state.usuario.id_paciente);
    const informacion = useSelector(state => state.informacion.info_DB);
    const lista_usada = useSelector(state => state.informacion.lista_usada);
    const lista = useSelector(state => state.ejercicio.lista);
    const minuscula = useSelector(state => state.configuracion.minuscula);
    const sesion = useSelector((state) => state.ejercicio.sesion);

    const GoodWork = () => new Audio('/sounds/sonido_bien.mp3').play();
    const TryAgain = () => new Audio('/sounds/sonidoMal.mp3').play();

    const almacenar = (e, index) => {
        e.preventDefault();

        setFraseElegida(index);
    }

    const verificar = (e) => {
        e.preventDefault();
        if (fraseElegida === '') {
            return;
        }
        if (randomPalabra[fraseElegida].toUpperCase() !== comparar.frase_1.toUpperCase()) {
            console.log('mal')
            setDisable(true);
            setContarErrores(contarErrores + 1);
            setIsIncorrect(true);
            setTimeout(() => {
                setIsIncorrect(false);
            }, 300);
            TryAgain();
            setTimeout(() => {
                setDisable(false);
                setFraseElegida('');
            }, 1000);
        } else {
            console.log('bien');
            setDisable(true);
            setIsCorrect(true);
            GoodWork();
            setTimeout(() => {
                setIsCorrect(false);
            }, 300);
            if (count < indexes) {
                setTimeout(() => {
                    setDisable(false);
                    setCount(count + 1);
                    setFraseElegida('');
                }, 300);
            } else {
                setTimeout(() => {
                    dispatch(finalizarEjercicioAction());
                }, 1000);
            }
        }

    }

    useEffect(() => {
        dispatch(setearEjercicioAction('CL1') );
        dispatch(setearUrlAnteriorAction('lecto-escritura/comprension-lectora/'));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        setComparar(informacion[count-1]);
        setIndexes(Object.keys(informacion).length);
    }, [count, informacion])

    useEffect(() => {
        if(finalizar){
            const informacion = {
                config,
                payload: {
                    'ejercicio': "CL1",
                    'errores': contarErrores,
                    'id_paciente': id_paciente,
                    'lista_usada': lista_usada,
                    'lista': lista,
                    sesion
                }
            }
            dispatch( almacenarAction(informacion) );
            navigate("/escritorio/metodos/finalizar-ejercicio");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [finalizar]);

    useEffect(() => {
        if(comparar === undefined){
            return;
        }
        const lista = [];
        lista.push(comparar.frase_1);
        lista.push(comparar.frase_2);
        if(comparar.frase_3) {lista.push(comparar.frase_3)};

        function shuffle(array) {
            let currentIndex = array.length, randomIndex;

            // While there remain elements to shuffle...
            while (currentIndex !== 0) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;

                // And swap it with the current element.
                [array[currentIndex], array[randomIndex]] = [
                    array[randomIndex], array[currentIndex]];
            }
            return array;
        }
        const newShuffleList = shuffle(lista);
        setRandomPalabra(newShuffleList)
    }, [comparar]);

    return (
        <Fragment>
            <HeaderEjercicios estrellas={true} carrito={true} minMay={true} />
            {iniciar
                ?
                <ContainerFlex height="100%" width="100%" display="flex" direction="column" justify="center">
                    <ContainerFlex display="flex" direction="column" justify="center" align="center" margin="auto" height="100%" width="100%">
                        <ContainerFlex display="flex" direction="column" height="100%" width="85%" widthmob="95%"
                            isCorrect={isCorrect}
                            isIncorrect={isIncorrect}
                        >
                            <ContainerFlex display="flex" align="center" justify="center" width="100%">
                                <Img wlg="" hlg="45vh" wd="" hd="42vh" wt="" ht="42vh" wm="" hm="35vh" width="" height="42vh"
                                src={`/img/${comparar.imagen_url_1}.png`} />
                            </ContainerFlex>

                            <BtnLetra $minMay={minuscula} margin="0.5rem 0" font="1.2rem" bg={fraseElegida === 0 ? "#23AAAF" : "rgba(250,250,250,1)"} shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" radius="25px" border="none" height="10vh" capitalizar={true} fontmob="1.05rem"
                                disabled={disable}
                                onClick={(e) => { almacenar(e, 0) }}
                            >
                                {randomPalabra[0]}
                            </BtnLetra>

                            <BtnLetra $minMay={minuscula} margin="0.5rem 0" font="1.2rem" bg={fraseElegida === 1 ? "#23AAAF" : "rgba(250,250,250,1)"} shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" radius="20px" border="none" height="10vh" capitalizar={true} fontmob="1.05rem"
                                disabled={disable}
                                onClick={(e) => { almacenar(e, 1) }}
                            >
                                {randomPalabra[1]}
                            </BtnLetra>
                            {randomPalabra[2] ? 
                            <BtnLetra $minMay={minuscula} margin="0.5rem 0" font="1.2rem" bg={fraseElegida === 2 ? "#23AAAF" : "rgba(250,250,250,1)"} shadow="0px 4px 4px rgba(0, 0, 0, 0.25)" radius="20px" border="none" height="10vh" capitalizar={true} fontmob="1.05rem"
                                disabled={disable}
                                onClick={(e) => { almacenar(e, 2) }}
                            >
                                {randomPalabra[2]}
                            </BtnLetra>
                            : null }

                        </ContainerFlex>
                    </ContainerFlex>
                    
                    <ContainerFlex margin="0 0rem 0 0rem" width="90%" justify="space-between" display="flex" align="center">
                        <BotoneraBottom miniInstrucciones={miniInstrucciones} />
                        <AvanzarBtn
                            disabled={disable}
                            onClick={(e) => verificar(e)}
                        >
                            <AvanzarImg src={'/img/play.png'} /> 
                        </AvanzarBtn>
                    </ContainerFlex>
                </ContainerFlex>
                :
                <Instrucciones instrucciones={instrucciones} />
            }
        </Fragment>
    );
}

export default CL1;